import { useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const testimonials = [
  { name: "Mrs. Tan", area: "Bukit Timah", date: "Feb 2026", text: "After trying two other agencies, Happy Home matched us with someone who felt like family from day one. Three years later, she's still with us. The Precision Match really works." },
  { name: "The Lim Family", area: "Woodlands", date: "Jan 2026", text: "Carol took the time to understand what we actually needed — not just what we said on paper. Our helper is amazing with our elderly mum and has become a second daughter to her." },
  { name: "Mr. & Mrs. Kumar", area: "East Coast", date: "Dec 2025", text: "We're an expatriate family and needed someone great with two young kids and our Golden Retriever. Grace has been with us for 4 years and we can't imagine life without her." },
  { name: "Ms. Chen", area: "Novena", date: "Nov 2025", text: "The 365-day support is real. When we had a small issue in month three, George called back within an hour and helped us work it out. Genuinely committed people." },
  { name: "The Wong Family", area: "Sentosa Cove", date: "Oct 2025", text: "Anna is a gift. She has such patience and warmth with our son who has autism. Happy Home understood exactly what we needed and delivered the right person the first time." },
  { name: "Mrs. Rajah", area: "Katong", date: "Sep 2025", text: "Refined, professional, human. Happy Home doesn't feel like a maid agency — it feels like a concierge that truly cares. Highly recommend to any Singapore family." },
];

export default function TestimonialsCarousel() {
  const [idx, setIdx] = useState(0);
  const total = testimonials.length;

  const next = useCallback(() => setIdx((i) => (i + 1) % total), [total]);
  const prev = () => setIdx((i) => (i - 1 + total) % total);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <section className="bg-[#F9F9F7]" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 sm:py-32">
        <div className="flex items-end justify-between mb-16 flex-wrap gap-4">
          <div>
            <div className="overline mb-4">Verified Reviews</div>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#0A1128] leading-tight">322+ Singapore families,<br/><span className="italic text-[#688A4E]">one story</span> at a time.</h2>
          </div>
          <div className="text-sm text-gray-500">
            <span className="font-semibold text-[#0A1128]">4.3★</span> · Google Reviews · Est. 2006
          </div>
        </div>

        <div className="relative bg-white border border-gray-200 p-10 sm:p-16 min-h-[320px]">
          <Quote className="w-10 h-10 text-[#688A4E] mb-6"/>
          <blockquote key={idx} className="font-serif italic text-2xl sm:text-3xl leading-[1.35] text-[#0A1128] mb-8 fade-up" data-testid={`testimonial-${idx}`}>
            "{testimonials[idx].text}"
          </blockquote>
          <div className="flex items-center justify-between flex-wrap gap-6">
            <div className="text-sm">
              <div className="font-semibold text-[#0A1128]">{testimonials[idx].name}</div>
              <div className="text-gray-500">{testimonials[idx].area} · {testimonials[idx].date}</div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex gap-2">
                {testimonials.map((_, i) => (
                  <button key={i} onClick={() => setIdx(i)} data-testid={`testimonial-dot-${i}`} className={`h-1.5 transition-all ${i === idx ? "w-8 bg-[#688A4E]" : "w-4 bg-gray-300"}`} aria-label={`Go to review ${i+1}`}/>
                ))}
              </div>
              <div className="flex gap-2">
                <button onClick={prev} data-testid="testimonial-prev" className="w-10 h-10 border border-[#0A1128] flex items-center justify-center hover:bg-[#0A1128] hover:text-white transition" aria-label="Previous"><ChevronLeft className="w-4 h-4"/></button>
                <button onClick={next} data-testid="testimonial-next" className="w-10 h-10 border border-[#0A1128] flex items-center justify-center hover:bg-[#0A1128] hover:text-white transition" aria-label="Next"><ChevronRight className="w-4 h-4"/></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
